/**
 * Services Routes
 */
/* eslint-disable */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import {
  AsyncManageServicesComponent,
  AsyncAddServiceComponent,
  AsyncModifyServiceComponent,
} from "../../components/AsyncComponent/AsyncComponent";

// async components

const Forms = ({ match }) => (
  <React.Fragment>
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/manage`} />
      <Route
        path={`${match.url}/view-all`}
        component={AsyncManageServicesComponent}
      />
    </Switch>
  </React.Fragment>
);

export default Forms;
